import {Link} from '@github-ui/react-core/link'
import type {PullRequestCommitInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {usePullRequestBasePath} from '../../../../stores/selectors'

export function PullRequestCommitText({info}: {info: PullRequestCommitInfo}) {
  const {sha, shortMessageText} = info
  const basePath = usePullRequestBasePath()

  return (
    <code>
      <Link className="color-fg-muted text-underline" to={`${basePath}/commits/${sha}`}>
        {shortMessageText ?? `pushed ${sha.slice(0, 7)}`}
      </Link>
    </code>
  )
}
